import styled from 'styled-components';

interface ContainerProps {
	checked: boolean;
}

export const Container = styled.div<ContainerProps>`
	display: flex;
	align-items: center;
	gap: 8px;
	margin-top: 48px;
	padding: 12px 16px;
	border-radius: 8px;
	background-color: ${({ theme, checked }) => (checked ? theme.gray[200] : theme.gray[100])};
	border: 1px solid ${({ theme }) => theme.gray[200]};
	cursor: pointer;
	transition: background-color 0.2s ease, border-color 0.2s ease;

	&:hover {
		// border: 1px solid ${({ theme }) => theme.gray[400]};
		box-shadow: 0 0 0 3px ${({ theme }) => `${theme.gray[200]}40`};
	}
`;

export const Checkbox = styled.input`
	width: 18px;
	height: 18px;
	cursor: pointer;
	accent-color: ${({ theme }) => theme.blue[500]};
`;

export const Label = styled.label`
	font-size: 14px;
	color: ${({ theme }) => theme.gray[700]};
	cursor: pointer;
	flex: 1;
	user-select: none;
	pointer-events: none;
`;

export const SceneName = styled.span`
	font-weight: 500;
	color: ${({ theme }) => theme.gray[900]};
	user-select: none;
	pointer-events: none;
`;
